export default __webpack_public_path__ + "static/media/WhitePencel.f6903429.svg";